import { Tab, TabList, Tabs } from '@carbon/react';
import { useHistory } from 'react-router-dom';
import style from './tabs.module.scss';
import { TitleWorkspaceResponse } from 'types/api-responses';

const getSelectedTabIndex = (pathname: string, workspaceHref: string) => {
  if (pathname === workspaceHref) return 0;
  if (pathname.includes('documents')) return 1;
  if (pathname.includes('runsheet')) return 2;
  if (pathname.includes('wells')) return 3;
  if (pathname.includes('entities')) return 4;
  return 0;
};
const WorkspaceTabs = ({
  titleWorkspace,
}: {
  titleWorkspace: TitleWorkspaceResponse;
}) => {
  const resources = titleWorkspace.resources;
  const workspaceHref = titleWorkspace.href;
  const history = useHistory();

  const selectedTabIndex = getSelectedTabIndex(
    location.pathname,
    workspaceHref
  );

  const tabRoutes = [
    workspaceHref,
    resources.documents.href,
    resources.runsheet.href,
    resources.wells.href,
    resources.entities.href,
  ];

  return (
    <div className={style.tabs}>
      <Tabs
        selectedIndex={selectedTabIndex}
        onChange={({ selectedIndex }) => {
          history.push(tabRoutes[selectedIndex]);
        }}
      >
        <TabList contained>
          <Tab id="workspace-overview">Workspace Overview</Tab>
          <Tab id="document_index">Document Index</Tab>
          <Tab id="runsheet">Runsheet</Tab>
          <Tab id="wells">Wells</Tab>
          <Tab id="entities">Entities</Tab>
        </TabList>
      </Tabs>
    </div>
  );
};

export { WorkspaceTabs };
